import type { TextareaHTMLAttributes } from 'react'

import { cn } from '@/lib/cn'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export function Textarea({ className, invalid = false, rows = 3, ...props }: TextareaProps) {
  return (
    <textarea
      aria-invalid={invalid || undefined}
      className={cn(
        'h-[76px] min-h-[76px] w-full resize-y rounded-lg border bg-white px-3 py-2 text-sm leading-[22px] text-[var(--color-text)] shadow-[var(--shadow-control)] outline-none transition-colors',
        'placeholder:text-[var(--color-control-placeholder)] focus:border-[var(--color-primary)] focus:ring-2 focus:ring-[var(--color-primary-soft)]',
        props.disabled
          ? 'cursor-not-allowed border-[var(--color-panel-border)] bg-[var(--color-surface-muted)] opacity-70 shadow-none'
          : invalid
            ? 'border-[var(--color-danger)]'
            : 'border-[var(--color-control-border)] hover:border-[var(--color-control-border-hover)]',
        className,
      )}
      rows={rows}
      {...props}
    />
  )
}
